import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The best copypasta ever copy pasted",
  "description": "",
  "published": "2010-01-08T00:00:00.000Z",
  "redirect_from": ["/blog/the-best-copypasta-ever-copy-pasted/swizec/1066"],
  "categories": "funny, intrigues, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://commons.wikipedia.org/wiki/Image:%C3%89douard-Henri_Avril_%2813%29.jpg"
        }}></a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      